import { graphql } from "react-relay";

export const PERMISSION_QUERY = graphql`
	query permissionBasedNavigation_Query {
		Viewer {
			Auth {
				currentUser {
					permissionsInAccount
					user {
						name
					}
					accounts {
						id
						name
					}
				}
				...generateAppJwt_AuthViewerSchemaFragment
			}
		}
	}
`;

export const FEATURE_TOGGLES_QUERY = graphql`
	query permissionBasedNavigation_featureToggles_Query {
		FeatureToggle {
			activeFeatureToggles
		}
	}
`;
